import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'clientes/';

export interface Cliente {
    id: number;
    usuario: {
        id: number;
        first_name: string;
        last_name: string;
        email: string;
        tipo_nivel_usuario?: {
            id: number;
            nombre: string;
            perfil_asociado?: string;
            rol?: string;
        } | null;
    } | null;
    telefono: string | null;
    ci_nit: string | null;
    fecha_creacion?: string;
    foto_url?: string | null;
    declaracion_jurada_firmada?: boolean;
    foto_declaracion_jurada_url?: string | null;
    fecha_declaracion_jurada?: string | null;
}

export const fetchClientes = async (): Promise<Cliente[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Cliente[]>(API_URL);
        return response.data;
    });
};

export const createCliente = async (data: {
    usuario?: number | null;
    telefono?: string | null;
    ci_nit?: string | null;
    foto?: File | null;
    foto_declaracion_jurada?: File | null;
    declaracion_jurada_firmada?: boolean;
}) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        if (data.usuario !== undefined && data.usuario !== null) formData.append('usuario', String(data.usuario));
        if (data.telefono !== undefined) formData.append('telefono', data.telefono ?? '');
        if (data.ci_nit !== undefined) formData.append('ci_nit', data.ci_nit ?? '');
        if (data.foto) formData.append('foto', data.foto);
        if (data.foto_declaracion_jurada) formData.append('foto_declaracion_jurada', data.foto_declaracion_jurada);
        if (data.declaracion_jurada_firmada !== undefined) formData.append('declaracion_jurada_firmada', String(data.declaracion_jurada_firmada));

        const response = await axiosInstance.post(API_URL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const updateCliente = async (
    id: number,
    data: {
        telefono?: string | null;
        ci_nit?: string | null;
        foto?: File | null;
        foto_declaracion_jurada?: File | null;
        declaracion_jurada_firmada?: boolean;
    }
) => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();
        if (data.telefono !== undefined) formData.append('telefono', data.telefono ?? '');
        if (data.ci_nit !== undefined) formData.append('ci_nit', data.ci_nit ?? '');
        if (data.foto) formData.append('foto', data.foto);
        if (data.foto_declaracion_jurada) formData.append('foto_declaracion_jurada', data.foto_declaracion_jurada);
        if (data.declaracion_jurada_firmada !== undefined) formData.append('declaracion_jurada_firmada', String(data.declaracion_jurada_firmada));

        const response = await axiosInstance.put(`${API_URL}${id}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    });
};

export const deleteCliente = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};
